/**
 * Created by Omar Alejandro Leonor Avalos on 2017-08-03.
 */
import React, { Component } from 'react';
import { numberToWords } from '../../common/numbersToWords';
import { COINS } from '../../data/selects';

class Totals extends Component {
    render() {
        const { children, customHouse, expensesTotal, subtotal, balance, coin, preInvoiceTypeConfig: { expenses, services } } = this.props;
        const selectedCoin = COINS.find(item => item.id === coin);

        return (
            <div className="row padding-1 prefactura-total margin-top-2">
                {
                    expenses &&
                    <div className="display-flex-center margin-top-1">
                        <div className="col-md-8 col-xs-12 display-flex-center" />
                        <div className="col-md-2 col-xs-12 display-flex-center display-flex-just-end">
                            <p className="text-bold text-color-light">
                                Gastos efectuados por su cuenta
                        </p>
                        </div>
                        <div className="col-md-3 col-xs-12 display-flex-center display-flex-just-end">
                            <h4 className="no-margins p-white">
                                {expensesTotal.formatMoney()}
                            </h4>
                        </div>
                    </div>
                }
                {
                    services &&
                    <div className="display-flex-center margin-top-1">
                        <div className="col-md-8 col-xs-12 display-flex-center" />
                        <div className="col-md-2 col-xs-12 display-flex-center display-flex-just-end">
                            <p className="text-bold text-color-light">
                                Gastos por despacho aduanero
                        </p>
                        </div>
                        <div className="col-md-3 col-xs-12 display-flex-center display-flex-just-end">
                            <h4 className="no-margins p-white">
                                {customHouse.formatMoney()}
                            </h4>
                        </div>
                    </div>
                }
                <div className="display-flex-center margin-top-1">
                    <div className="col-md-8 col-xs-12 display-flex-center" />
                    <div className="col-md-2 col-xs-12 display-flex-center display-flex-just-end">
                        <p className="text-bold text-color-light">
                            Subtotal
                        </p>
                    </div>
                    <div className="col-md-3 col-xs-12 display-flex-center display-flex-just-end">
                        <h4 className="no-margins p-white">
                            {subtotal.formatMoney()}
                        </h4>
                    </div>
                </div>
                <div className="display-flex-center margin-top-1">
                    <div className="col-md-8 col-xs-12 display-flex-center" />
                    <div className="col-md-2 col-xs-12 display-flex-center display-flex-just-end">
                        <label
                            htmlFor="__"
                            className="label label-danger font-12px p-white" >
                            Anticipo
                    </label>
                    </div>
                    <div className="col-md-3 col-xs-12 display-flex-center display-flex-just-end">
                        <h4 className="no-margins p-white">
                            {children}
                        </h4>
                    </div>
                </div>
                <div className="display-flex-center margin-top-1">
                    <div className="col-md-7 col-xs-12 display-flex-center" />
                    <div className="col-md-3 col-xs-12 display-flex-center display-flex-just-end">
                        <p className="text-bold text-color-light">
                            Total pendiente de liquidar en Moneda Nacional
                        </p>
                    </div>
                    <div className="col-md-3 col-xs-12 display-flex-center display-flex-just-end">
                        <label
                            htmlFor="_"
                            className="label label-primary p-white text-bold"
                            style={{ fontSize: '15px' }}
                        >
                            {balance.formatMoney()}
                        </label>
                    </div>
                </div>
                <div className="display-flex-center margin-top-1">
                    <div className="col-xs-12 display-flex-center display-flex-just-end">
                        <p
                            className="p-white text-bold"
                            style={{ fontSize: '15px' }}
                        >
                            {
                                // Modo de uso: 500,34 USD
                                numberToWords(balance, {
                                    plural: selectedCoin.plural,
                                    singular: selectedCoin.singular,
                                    centPlural: 'CENTAVOS',
                                    centSingular: 'CENTAVO'
                                })
                            }
                        </p>
                    </div>
                </div>

            </div>
        );
    }
}

export default Totals;



// WEBPACK FOOTER //
// ./forms/customPrefactura/totals.js